// src/pages/PilotComplete.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import BottomBar from "../../components/layout/BottomBar";

export default function PilotComplete() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white font-sans flex flex-col pb-24">
      {/* Header */}
      <div
        className="bg-[#E9652D] h-[200px] flex items-center justify-center"
        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      >
        <h1 className="text-white text-[28px] font-bold">
          Well done!
        </h1>
      </div>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="relative max-w-md w-full bg-white border border-orange-200 rounded-2xl shadow-lg px-6 py-8 text-center overflow-hidden">
          {/* Left party popper */}
          <div className="absolute -left-4 top-6 animate-bounce">
            <span role="img" aria-hidden="true" className="text-3xl">
              🎉
            </span>
          </div>

          {/* Right party popper */}
          <div className="absolute -right-4 bottom-6 animate-bounce">
            <span role="img" aria-hidden="true" className="text-3xl">
              🎉
            </span>
          </div>

          <h2 className="text-[20px] font-bold text-[#333] mb-3">
            Thank you for participating in our pilot!
          </h2>

          <p className="text-[14px] text-[#555] leading-relaxed mb-4">
            You&apos;ve completed all three quests and reached the end of this pilot journey.
          </p>
          <p className="text-[14px] text-[#555] leading-relaxed mb-6">
            Your effort and feedback help us build something even better for entrepreneurs like you.
          </p>

          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="inline-flex items-center justify-center rounded-[10px] bg-black px-6 py-2 text-white text-[16px] font-bold hover:bg-neutral-800"
          >
            Back to Dashboard
          </button>
        </div>
      </main>

      <BottomBar />
    </div>
  );
}
